import { registerApplication } from 'single-spa';
import { queryClient } from '../config/query_client';
const commonProps = {
    appId: 'bif',
    landscape: window.bifrostWeb.landscape,
    backend: window.bifrostWeb.backend,
    queryClient,
};
const bifrostCssLoaded = {};
const ensurePromise = (moduleName) => {
    if (bifrostCssLoaded[moduleName]) {
        return bifrostCssLoaded[moduleName];
    }
    let resolveFn = undefined;
    const promise = new Promise(resolve => {
        resolveFn = resolve;
    });
    if (!resolveFn) {
        throw new Error('Promise constructor did not run');
    }
    bifrostCssLoaded[moduleName] = { promise, resolve: resolveFn };
    return bifrostCssLoaded[moduleName];
};
export const registerModule = ({ name, isAlwaysActive = false, props = {} }) => {
    const jsModuleName = `@bifrost/${name}`;
    const cssModuleName = `@bifrost/${name}-styles`;
    registerApplication({
        name: jsModuleName,
        app: async () => {
            // Always wait for CSS before importing JS to prevent FOUC.
            // If CSS is already loaded the promise is resolved and this is a no-op.
            await ensurePromise(name).promise;
            return System.import(jsModuleName);
        },
        activeWhen: isAlwaysActive ? () => true : `/${name}`,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
    registerApplication({
        name: cssModuleName,
        app: async () => {
            const link = document.createElement('link');
            return {
                async bootstrap() {
                    const defaultImports = await window.importMapOverrides.getDefaultMap();
                    const overrideImports = window.importMapOverrides.getOverrideMap();
                    const finalImports = window.importMapOverrides.mergeImportMap(defaultImports, overrideImports);
                    const cssModuleUrl = finalImports.imports[cssModuleName];
                    link.rel = 'stylesheet';
                    link.href = cssModuleUrl;
                    link.type = 'text/css';
                },
                async mount() {
                    const { resolve } = ensurePromise(name);
                    const onLoadOrError = () => {
                        resolve();
                    };
                    // tell js module that css has loaded (or errored)
                    link.onload = onLoadOrError;
                    link.onerror = onLoadOrError;
                    document.head.append(link);
                },
                async unmount() {
                    link.remove();
                    delete bifrostCssLoaded[name];
                },
            };
        },
        activeWhen: () => true,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
};
